export default arg => !arg;
